<template>
  <div
    id="app"
    :class="{'is-ipad': isIPad }"
  >
    <app-main-menu v-if="!this.$route.meta.hideMainMenu && $store.state.account.user" />
    <side-bar v-if="!this.$route.meta.hideMainMenu && $store.state.account.user" />
    <router-view />
    <base-toast-modal :key="`toast-${$route.fullPath}`" />
    <base-confirm-dialog-container :key="`confirm-${$route.fullPath}`" />
  </div>
</template>
<script>

import Vue from 'vue';
import heartbeat from '@/components/mixins/heartbeat';
import whichbrowser from '@/components/mixins/whichbrowser';
import { BroadcastChannel } from 'broadcast-channel';
import * as Sentry from '@sentry/browser';
// import { captureMessage } from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import MainNavigationContainer from '@/components/Navigation/MainNavigationContainer';
import LeftNavigation from '@/components/Navigation/LeftNavigation';
import {
  SENTRY_DSN,
  USE_SENTRY,
} from './config';

export default {
  name: 'App',
  components: {
    'app-main-menu': MainNavigationContainer,
    'side-bar': LeftNavigation,
  },
  mixins: [
    heartbeat,
    whichbrowser,
  ],
  mounted() {
    // We are listening if any tab has logged out
    // Event sent by account.module.js -> logout
    const channel = new BroadcastChannel('app-data');
    channel.onmessage = (msg) => {
      if (this.$route.name !== 'LoginPage') {
        if (msg === 'logout') {
          // eslint-disable-next-line
          location.reload();
        }
      }
    };

    if (USE_SENTRY) {
      console.log('[initializing sentry from App.vue]');

      // https://docs.sentry.io/platforms/javascript/
      // http://sentry.helloseer.com/settings/seer/projects/seer-frontend/install/javascript-vue/
      const SENTRY_ENVIRONMENT_DEVELOPMENT = 'development',
        SENTRY_ENVIRONMENT_LOCAL = 'local',
        // SENTRY_ENVIRONMENT_STAGING = 'staging',
        SENTRY_ENVIRONMENT_PRODUCTION = 'production';

      const deriveSentryEnvironment = () => { // FIXME ghetto and half-functioning
        let senv;
        const onDevLaptop = process.platform === 'darwin'; // XXX
        if (onDevLaptop) {
          senv = SENTRY_ENVIRONMENT_LOCAL;
        } else if (process.env.NODE_ENV === 'production') {
          senv = SENTRY_ENVIRONMENT_PRODUCTION;
        } else {
          senv = SENTRY_ENVIRONMENT_DEVELOPMENT; // e.g. dev.helloseer.com/login
        }
        return senv;
      };

      Sentry.init({
        Vue,
        dsn: SENTRY_DSN,
        environment: deriveSentryEnvironment(),
        integrations: [new Integrations.BrowserTracing()],
        logErrors: true,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
      });
    }
    // captureMessage('App.vue:79   will captureMessage() work???');   // <-- THIS WORKS
  },
};

</script>
